import * as React from 'react';
import { SVGProps } from 'react';

const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={13}
        height={14}
        viewBox='0 0 13 14'
        fill="none"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M1.393 12.107 11.606 1.894m0 10.213L1.393 1.894"
        />
    </svg>
);
export default CloseIcon;